/**
 * A report whose programmes could not be read, and the way back to them.
 *
 * @module components/reports/ReportLoadError
 */

import React from "react";

import { Button, ErrorAlert } from "@/components/ui";
import { useReportScope } from "@/reports/ReportTenantScope";

export function ReportLoadError({
  "data-testid": testId,
}: {
  "data-testid": string;
}): React.ReactElement {
  const { refresh } = useReportScope();
  return (
    <ErrorAlert data-testid={testId}>
      <span className="flex flex-wrap items-center gap-3">
        The programmes could not be loaded.
        <Button
          size="sm"
          variant="outline"
          icon="arrow-clockwise"
          onClick={() => {
            refresh().catch(() => undefined);
          }}
        >
          Try again
        </Button>
      </span>
    </ErrorAlert>
  );
}
